import { Language, Subsidiary } from '@coolblue-development/constants';
export const getCorporateDeliveryUrl = (language) => {
    if (language === Language.ENGLISH) {
        return 'https://www.coolblue.de/en/c/coolblue-delivery-service.html';
    }
    return 'https://www.coolblue.de/c/coolblue-lieferservice.html';
};
export const getPostalCodeRegex = (subsidiary) => {
    switch (subsidiary) {
        case Subsidiary.BE:
            return /^\d{4}$/;
        case Subsidiary.DE:
            return /^\d{5}$/;
        case Subsidiary.NL:
            return /^\d{4}\s?[A-Z]{2}$/;
        default:
            return /^d{5}$/;
    }
};
//# sourceMappingURL=Constants.js.map